import * as React from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import Isvg from 'react-inlinesvg';
// import * as _ from 'lodash';

import RequestIcon from 'app/images/icons/tick2.svg';

export interface IStep {
  text: string;
  number: number;
  complete: boolean;
  active: boolean;
}

export interface ProgressIndicatorProps {
  steps: IStep[];
}

export default class ProgressIndicator extends React.Component<
  ProgressIndicatorProps,
  {}
> {
  static propTypes = {
    steps: PropTypes.array,
  };

  static defaultProps = {
    steps: [],
  };

  renderStep = (step: IStep): React.ReactNode => (
    <div
      className={classnames(
        'step-container',
        { completed: step.complete },
        { active: step.active },
      )}
      key={step.number}
    >
      <div className="step-number">
        {step.complete ? (
          <Isvg className="nav-link-icon" src={RequestIcon} />
        ) : (
          step.number
        )}
      </div>
      <div className="step-text">{step.text}</div>
    </div>
  );

  renderSteps = (): React.ReactNode[] => this.props.steps.map((step) => this.renderStep(step));

  render(): React.ReactNode {
    return (
      <div className="step-bar-container">
        <div className="step-bar">{this.renderSteps()}</div>
      </div>
    );
  }
}
